import { ButtonProps } from "@mui/material/Button";
import { ReactNode } from "react";
import { StarsIcon } from "shared/theme/icons/StarsIcon";
import { StyledAIButton } from "./styled";

export type AIButtonProps = {
  title: ReactNode;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  loading?: boolean;
} & ButtonProps;

const AIButton = ({
  title,
  onClick,
  disabled,
  loading,
  ...buttonProps
}: AIButtonProps) => {
  return (
    <StyledAIButton
      onClick={onClick}
      disabled={disabled || loading}
      data-loading={loading ? "true" : undefined}
      {...buttonProps}
    >
      <span className="button-content">
        {!loading && title}
        <StarsIcon size={20} />
      </span>
    </StyledAIButton>
  );
};

export default AIButton;
